// Added by Sejune Oh on 2020-02-24
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { NumberFormat } from "@/stores/dataStorage"

/**
 *  [1] Interface
 *  [2] Type
 *  [3] Enum
 *  [4] Constants
 */

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [1] Interface
export interface DataStorage {
  id?: string
  fk_data_node_id?: string
  fk_import_node_id?: string
  fk_group_id?: string
  data_token?: string
  import_token?: string
  name?: string
  description?: string
  db_driver_name?: DBDriverType
  db_connection_string?: string
  scalable?: boolean
  root_dir_path?: string
  root_dir_credential?: string
  created_at?: string
  updated_at?: string
  deleted_at?: string
}

export interface DataStorageCustomColumn {
  id?: string
  key?: string
  display_name?: string
  type?: CustomColumnTypes
  possible_values?: string
  user_defined?: boolean
  formats?: NumberFormat[]
  created_at?: string
  updated_at?: string
  deleted_at?: string
}

export interface DisplableCustomColumn extends DataStorageCustomColumn {
  possible_values_str?: string
  delete_btn?: JSX.Element
  index?: number
  isUpdated?: boolean
}

interface DeletionRuleCondition {
  enable: boolean
  attribute: 'IMPORTED_DATE' | 'STUDY_DATE' | 'STUDY_STATUS' | 'STUDY_TAG'
  operation: string
  values: string[]
}
export interface EmergencyRule {
  enable: boolean
  threshold: number // 잔여량 %
  conditions: DeletionRuleCondition[] // imported date || study date desc
}

interface ScheduleItem {
  possible_days_of_week: string[]
  possible_time_from: string
  possible_time_to: string
}

export interface ScheduleRule {
  enable: boolean
  threshold: number // 잔여량 %
  schedule_items: ScheduleItem[]
  conditions: DeletionRuleCondition[]
}

export interface CleanupRule {
  data_token: string
  emergency?: EmergencyRule,
  scheduleRule?: ScheduleRule
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [2] Type

export type DBDriverType = 'sqlite3' | 'mssql'

export type Driver = {
  id: DBDriverType
  label: string
}

export type CustomColumnTypes = 'int' | 'real' | 'string' | 'bool' | 'enum' | 'external_enum'


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [3] Enum

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// # [4] Constants
export const DEFAULT_DRIVERS: Driver[] = [
  {
    id: 'sqlite3',
    label: 'Sqlite3',
  },
  {
    id: 'mssql',
    label: 'MSSQL',
  },
]

export const CUSTOM_COLUM_TYPES: CustomColumnTypes[] = ['string', 'bool', 'enum', 'int', 'real', 'external_enum']

export const CUSTOM_COLUMN_KEY_LENGTH = { min: 1, max: 64 }

export const CUSTOM_COLUMN_DISP_NAME_LENGTH = { min: 1, max: 64 }
